<div class="container-fluid">
    <div class="row">
        <div class="col-xs-12 col-md-6 pb-20"
             [class.col-md-push-6]="formPosition === 'right'">
            <form #contactForm="ngForm" (ngSubmit)="onContactFormSubmit(contactForm)"
                  (keydown.enter)="$event.preventDefault()">
                <h2 class="heading">Do you have a question or feedback?</h2>
                <p class="subheading">Send us a message and we will get back to you.</p>

                <mat-form-field class="input-field">
                    <p>Your name<sup class="text-color-red">*</sup></p>
                    <input matInput placeholder="" [(ngModel)]="name" (keyup)="onNameInput($event)" name="name"
                           type="text"
                           required maxlength="30" autocomplete="off">
                </mat-form-field>

                <p id="phone-field-label">Your mobile number</p>
                <mat-form-field class="input-field">
                    <p matPrefix class="text-color-grey phone-prefix">+91</p>
                    <input matInput [(ngModel)]="phoneNumber" name="phoneNumber" autocomplete="off" maxlength="10">
                </mat-form-field>

                <mat-form-field class="input-field">
                    <p>Your email address<sup class="text-color-red">*</sup></p>
                    <input matInput placeholder="" maxlength="55" autocomplete="off" [(ngModel)]="email" name="email"
                           required
                           type="email">
                </mat-form-field>

                <mat-form-field class="input-field">
                    <p>Message<sup class="text-color-red">*</sup></p>
                    <textarea matInput autocomplete="off" [(ngModel)]="message" name="message" title="Your message"
                              required type="text"></textarea>
                </mat-form-field>
                <div class="captcha-container">
                    <app-captcha (resolved)="captchaResolved($event)" (error)="captchaError($event)"></app-captcha>
                </div>
                <div class="pull-right">
                    <div *ngIf="!shouldShowLoader">
                        <button mat-flat-button class="primary submit-contact-us" type="submit">SUBMIT</button>
                    </div>

                    <div *ngIf="shouldShowLoader">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>

                <div class="messages">
                    <span *ngIf="formSubmitted">Thank you for contacting us. We will get in touch with you shortly.</span>
                    <span class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</span>
                </div>
            </form>
        </div>

        <div class="col-md-6 visible-md-block visible-lg-block contact-us-right"
             [class.col-md-pull-7]="formPosition === 'right'">
            <div class="row call-us">
                <h2 class="text-color-finzy-blue" id="happy-to-help">Call us</h2>
                <div class="happy-to-help-description col-xs-12 col-md-6">
                    <h3 class="happy-to-help-description-heading">For Support</h3>
                    <h4 class="happy-to-help-line">Call us : <b>9341 300 300</b></h4>
                    <h4 class="happy-to-help-line">Email us : <b>support@finzy.com</b></h4>
                </div>
                <div class="happy-to-help-description col-xs-12 col-md-6">
                    <h3 class="happy-to-help-description-heading">For Grievances and Escalations</h3>
                    <h4 class="happy-to-help-line">Call us : <b>9513 330 562</b></h4>
                    <h4 class="happy-to-help-line">Email us : <b>grievances@finzy.com</b></h4>
                </div>
            </div>
            <div class="row">
                <h2 class="text-color-finzy-blue" id="happy-to-help">Office address</h2>
                <p id="cin-text">Bridge Fintech Solutions Private Limited<br>(CIN : U74999MH2016PTC286583)</p>
                <div class="happy-to-help-description col-xs-12 col-md-6">
                    <h3 class="happy-to-help-description-heading">Registered Office Address</h3>
                    <h4 class="happy-to-help-line-address">L&T Crescent Bay, T5 2002,</h4>
                    <h4 class="happy-to-help-line-address">Jerbai Wadia Road, Parel,</h4>
                    <h4 class="happy-to-help-line-address">Mumbai 400 012</h4>
                </div>
                <div *ngIf="activeFinzyVersion === 'FINZY_V1'" class="happy-to-help-description col-xs-12 col-md-6">
                    <h3 class="happy-to-help-description-heading">Corporate Office Address</h3>
                    <h4 class="happy-to-help-line-address">118, 1st Floor,</h4>
                    <h4 class="happy-to-help-line-address">80 Feet Road, Koramangala</h4>
                    <h4 class="happy-to-help-line-address">7th Block, Bengaluru 560095</h4>
                </div>
                <div *ngIf="activeFinzyVersion !== 'FINZY_V1'" class="happy-to-help-description col-xs-12 col-md-6">
                    <h3 class="happy-to-help-description-heading">Corporate Office Address</h3>
                    <h4 class="happy-to-help-line-address">1st Floor,BMTC Complex,Kuvempu </h4>
                    <h4 class="happy-to-help-line-address">Nagar, Stage 2, BTM Layout,</h4>
                    <h4 class="happy-to-help-line-address">Bengaluru, Karnataka, 560068</h4>
                </div>
            </div>
        </div>
    </div>
</div>
